(function(){
    'use strict';
    angular.module('Services').service('TrackingEventsService', TrackingEventsService);

    TrackingEventsService.$inject = [
        'Shipments',
        'toastr',
        '$filter'
    ];

    function TrackingEventsService(
        Shipments,
        toastr,
        $filter
    ) {
        return function(id, data) {
            var trackingEventsData = {
                data: []
            }
            init();
            function init() {
                if(data) {
                    trackingEventsData.data = formatData(data);
                }
                else {
                    getData();
                }
            }
            function getData(){
                Shipments.getTracking(id, function(data){
                   trackingEventsData.data = formatData(data.trackingEvents);
                }, function(error){
                    toastr.error(error.code, error.message);
                });
            }

            function formatData(data){
                var dates = [];
                var events = [];
                for(var i = 0; i  < data.length; i++) {
                    var date = $filter("bbaDate")(data[i].timestamp);
                    if(dates.indexOf(date) === -1) {
                        dates.push(date);
                    }
                } 
                for(var i = 0; i < dates.length; i ++) {
                    var eventObj = {};
                    eventObj.date = dates[i];
                    eventObj.data = [];
                    events.push(eventObj);
                }
                for(var i = 0; i < events.length; i++) {
                    for(var x = 0; x < data.length; x++) {
                        var dataDate = $filter("bbaDate")(data[x].timestamp);
                        var time = $filter("bbaDate")(data[x].timestamp, false, 'h:mm a');
                        var location = data[x].location;
                        var status = data[x].status;

                        if(events[i].date === dataDate) {
                            var dataObj = {};
                            dataObj.time = time;
                            dataObj.location = location;
                            dataObj.status = status.replace(/([A-Z]+)/g, ' $1').trim();
                            events[i].data.push(dataObj);
                        }
                    }
                }
                return events;
            }
            this.data = trackingEventsData;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/UX/TrackingEventsService.js